import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Delete, Edit } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../store/snackbarSlice/snackbarSlice";
import ROLES from "../../enums/Roles";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";

const GymUsersAdminPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [users, setUsers] = React.useState([]);

  const createNavigation = () => {
    navigate("/dashboard/users/gym-user/create-user");
  };

  const updateNavigation = (id) => {
    navigate(`/dashboard/users/gym-user/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this user?"
      );
      if (!confirmDelete) return;

      const response = await callBackendApi(`/users/${id}`, "DELETE");

      if (response && response.success) {
        dispatch(showSnackbar({ message: "User deleted successfully!" }));

        await getBlogPosts();
      } else {
        dispatch(
          showSnackbar({
            message:
              "Something went wrong while deleting the request. Please try again.",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "An error occurred with the request.",
        })
      );
    }
  };

  React.useEffect(() => {
    getBlogPosts();
  }, []);

  const getBlogPosts = async () => {
    const response = await callBackendApi(`/users?userType=${ROLES.CUSTOMER}`);
    if (response.success) {
      setUsers(response.data);
    } else {
      setUsers([]);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
    },
    { field: "email", headerName: "Email", flex: 1 },
    {
      field: "role",
      headerName: "Role",
      flex: 1,
    },
    {
      field: "is_active",
      headerName: "Active",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const active = params?.row?.is_active;
        return active ? "ACTIVE" : "NOT ACTIVE";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            width: "100%",
            height: "100%",
          }}
        >
          {" "}
          <IconButton
            onClick={() => updateNavigation(params.row.id)}
            color="primary"
          >
            <Edit />
          </IconButton>
          <IconButton
            onClick={() => handleDelete(params.row.id)} // Call the delete handler
            color="error" // Use error color for delete button
          >
            <Delete />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", maxWidth: "1700px", margin: "auto" }}>
      <Card className="my-5">
        <CardContent>
          <Grid item xs={12}>
            <h1>Employees</h1>
          </Grid>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                className="float-right"
                type="button"
                variant="contained"
                onClick={createNavigation}
              >
                New User
              </Button>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%" }}>
              <DataGrid
                rows={users}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={10}
                getRowId={(row) => row.id}
                slots={{ toolbar: GridToolbar }}
                autoHeight
                sx={{
                  width: "100%",
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#222",
                    color: "#fff",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #444",
                  },
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default GymUsersAdminPage;
